module.exports = __webpack_public_path__ + "d36c75e3d8880ebfece375fd7cd46787.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery-minicolors/jquery.minicolors.png
 ** module id = 666
 ** module chunks = 0
 **/